export default __webpack_public_path__ + "static/media/arrowRight.07df4681.svg";